import Location from 'umg-ember-backend/components/record-explorer/for/location';

<template><Location @records={{@model}} @recordType='location' /></template>
